import * as React from "react";
import { FeedItemTopOfMonth } from "../../../server/feed/buildfeed";
import { Entry } from "../models/entries";
import { EntryList } from "../DesignSystem/EntryList";
import { Button } from "../DesignSystem/Button";
import { ClockIcon } from "@heroicons/react/24/outline";

export const TopRecentTracks = ({
  topOfMonth,
}: {
  topOfMonth: FeedItemTopOfMonth;
}) => {
  if (topOfMonth.content.length === 0) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-800">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
        Top Recent Tracks
      </h2>

      <div className="-mx-2">
        <EntryList
          hideFilter
          hidePlayAll
          defaultCompoFilter={"main"}
          entries={topOfMonth.content.map((x) => new Entry(x))}
          hideStats
          avatar_urls={topOfMonth.content.map((x) =>
            [
              x.avatar_url_1,
              x.avatar_url_2,
              x.avatar_url_3,
              x.avatar_url_4,
              x.avatar_url_5,
            ].filter((x) => !!x)
          )}
          associatedCompos={topOfMonth.content.map(
            ({ compo_id, name, compo_type }) => ({
              compo_id,
              name,
              type: compo_type,
            })
          )}
        />
      </div>

      <div className="mt-3">
        <Button to="/entries" icon={<ClockIcon className="h-4 w-4" />}>
          Top All Time Tracks
        </Button>
      </div>
    </div>
  );
};
